export default {
  sourceType: {
    rules: [
      {
        required: true,
        message: "Выберите тип",
        trigger: "change"
      }
    ]
  },
  sourceChannel: {
    rules: [
      {
        required: true,
        message: "Выберите проект",
        trigger: ["change", "blur"]
      }
    ]
  },
  direction: {
    rules: [
      {
        required: true,
        message: "Выберите вид транзакции",
        trigger: "change"
      }
    ]
  },
  suspended: {
    rules: [
      {
        required: true,
        message: "Выберите состояние",
        trigger: "change"
      }
    ]
  },
  valute: {
    rules: [
      {
        required: true,
        message: "Выберите валюту",
        trigger: "change"
      }
    ]
  },
  balanceAccount: {
    rules: [
      {
        required: true,
        message: "Выберите баланс",
        trigger: "change"
      }
    ]
  },
  amount: {
    rules: [
      {
        required: true,
        message: "Введите сумму",
        trigger: ["change", "blur"]
      },
      {
        trigger: ["change", "blur"],
        validator(rule, value, callback) {
          if (!Number.isFinite(+value))
            return callback(new Error("Значение должно быть числом"));
          if (+value <= 0)
            return callback(new Error("Сумма должна быть больше 0"));
          return callback();
        }
      }
    ]
  },
  dateStart: {
    rules: [
      {
        required: true,
        message: "Дата открытия необходима",
        trigger: "blur"
      }
    ]
  },
  dateEnd: {
    rules: [
      {
        required: true,
        message: "Дата закрытия необходима",
        trigger: "blur"
      }
    ]
  },
  userName: {
    rules: [
      {
        required: true,
        message: "Введите идентификатор клиента",
        trigger: "blur"
      }
    ]
  },
  transactionId: {
    rules: [
      {
        required: true,
        message: "Введите идентификатор транзакции",
        trigger: "blur"
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/Ledger/validation.js